import React, { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { Col, Container, Row } from "react-bootstrap";
import breadcrumbImage from "../../assets/images/course/cousre.jpg";
import contactImage from "../../assets/images/Home/contactUs.png";
import { Link } from "react-router-dom";

const Contact = () => {
  const [fooder, setfooder] = useState("");
  const [errors, setErrors] = useState({});
const [bgImage, setBgImage] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });
  useEffect(() => {
    footerdata();
      bannerimg()
  }, []);
  const [message, setMessage] = useState("");
  const bannerimg = async () => {
            try {
              const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
              );
        
              const baseUrl = res.data.imagePath;
              const courseImage = res.data.home_setting[0]?.course_image;
        
              // Full image URL
              const fullUrl = baseUrl + courseImage;
        
              setBgImage(fullUrl);
            } catch (error) {
              console.error("Error fetching banner:", error);
            }
          };
  //form validation//
  const validate = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Invalid email format";
      }
    }

    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.length < 10) {
      newErrors.message = "Message should be at least 10 characters long";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
      // setstatus(res.data.status);
    } catch (error) {}
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, email, subject, message } = formData;
    if (!validate()) {
      // swal("Please Fill All Details Before Submit");
      //  swal({
      //     title: "Not submit",
      //     text: "Please Fill All Details Before Submit.",
      //     icon: "error",
      //     timer: 2000,
      //     buttons: false,
      //   });
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/contact`,
        {
          firstName,
          lastName,
          email,
          subject,
          message,
        }
      );

      if (res.data.success) {
        swal({
          title: "Message Sent!",
          text: "Thank you for contacting us.",
          icon: "success",
          timer: 2000,
          buttons: false,
        });
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          subject: "",
          message: "",
        });
        setErrors({});
      } else {
        swal("Error", res.data.message || "Failed to send message", "error");
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  return (
    <section className="course Contact">
      <div class="page_header"></div>
      <div className="rs-breadcrumbs breadcrumbs-overlay">
        <div className="breadcrumbs-img">
          <img src={bgImage} alt="Breadcrumbs bg" loading="lazy"/>
        </div>
        <div className="breadcrumbs-text white-color">
          <h1 className="page-title">Contact Us</h1>
        </div>
      </div>

      <Container>
        <section className="py-60">
          <Row className="align-items-center">
            <Col lg={6}>
              <h6 className="color-primary mb-8">–––– Contact Form</h6>
              <h2 className="mb-16 contact_head">
                Write Us Anytime, We Would
                <br /> Love To Hear From <span className="fm-sec">You!</span>
              </h2>
              {/* <p className="mb-32">
                Lorem ipsum dolor sit amet consectetur. Non convallis sed id{" "}
                <br />
                aliquam tempus. Volutpat tortor tincidunt egestas sit risus
                donec.
              </p> */}

              <form onSubmit={handleSubmit} noValidate>
                <Row>
                  <Col sm={6}>
                    <div className="mb-2">
                      <label className="mb-1">
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        // className="form-control mb-3"
                        className={`form-control mb-1 ${
                          errors.firstName ? "input-error" : ""
                        }`}
                        name="firstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                      {errors.firstName && (
                        <small className="text-danger">
                          {errors.firstName}
                        </small>
                      )}
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="mb-2">
                      <label className="mb-1">
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        // className="form-control mb-3"
                        className={`form-control mb-1 ${
                          errors.lastName ? "input-error" : ""
                        }`}
                        name="lastName"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                      {errors.firstName && (
                        <small className="text-danger">{errors.lastName}</small>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <div className="mb-2">
                      <label className="mb-1">
                        Enter Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        // className="form-control mb-3"
                        className={`form-control mb-1 ${
                          errors.email ? "input-error" : ""
                        }`}
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.firstName && (
                        <small className="text-danger">{errors.email}</small>
                      )}
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="mb-2">
                      <label className="mb-1">
                        Subject <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        // className="form-control mb-3"
                        className={`form-control mb-1 ${
                          errors.subject ? "input-error" : ""
                        }`}
                        name="subject"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleChange}
                      />
                      {errors.subject && (
                        <small className="text-danger">{errors.subject}</small>
                      )}
                    </div>
                  </Col>
                </Row>
                <div className="mb-2">
                  <label className="mb-1">
                    Message <span className="text-danger">*</span>
                  </label>
                  <textarea
                    // className="form-control mb-3"
                    className={`form-control mb-1 ${
                      errors.message ? "input-error" : ""
                    }`}
                    name="message"
                    rows="5"
                    placeholder="Message  "
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                  {errors.message && (
                    <small className="text-danger">{errors.message}</small>
                  )}
                </div>

                <div className="text-end mt-3">
                  <button type="submit" className="educate-btn">
                    <span className="educate-btn__curve"></span>
                    Send Message
                  </button>
                </div>
                {message && <div className="alert-msg mt-3">{message}</div>}
              </form>
            </Col>
            <Col lg={6}>
              <div className="educate-tilt">
                <img src={contactImage} alt="Contact" loading="lazy"/>
              </div>
            </Col>
          </Row>

          <div className="contact_links pt-60">
            <Row className="align-items-center">
              <Col lg={4}>
                <div className="contact_link_block mb-48 mb-lg-0">
                  <div className="icon">
                    <FaMapMarkerAlt />
                  </div>
                  <h6 className="dark-gray">{fooder.address}</h6>
                </div>
              </Col>
              <Col lg={4}>
                <Link
                  to={`tel:${fooder.mobile_number}`}
                  className="contact_link_block mb-48 mb-lg-0"
                >
                  <div className="icon">
                    <FaPhoneAlt />
                  </div>
                  <span className="h6">+91 {fooder.mobile_number}</span>
                </Link>
              </Col>
              <Col lg={4}>
                <Link
                  to={`mailto:${fooder.email_id}`}
                  className="contact_link_block"
                >
                  <div className="icon">
                    <FaEnvelope />
                  </div>
                  <span className="h6"> {fooder.email_id}</span>
                </Link>
              </Col>
            </Row>
          </div>
        </section>
      </Container>
    </section>
  );
};

export default Contact;
